import React, {Fragment} from 'react'
import {DropdownToggle, DropdownMenu, Nav, Button, NavItem, UncontrolledButtonDropdown} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faAngleDown, faPowerOff, faUserCircle} from '@fortawesome/free-solid-svg-icons'
import {Link} from 'react-router-dom'

import avatar from '../../../assets/utils/images/avatars/avatar.png'
import city3 from '../../../assets/utils/images/dropdown-header/city3.jpg'
import {useAuth} from '../../../Context'
import {decodeToken} from '../../../utils/scripts'

const UserBox = () => {
    const {auth, setAuth, setCompany} = useAuth()

    const {authentication} = auth
    const {id, sub, email, role} = decodeToken(authentication)

    const logOut = () => {
        setAuth({})
        setCompany({})
        window.location.href = '/login'
    }

    return (
        <Fragment>
            <div className="header-btn-lg pr-0">
                <div className="widget-content p-0">
                    <div className="widget-content-wrapper">
                        <div className="widget-content-left">
                            <UncontrolledButtonDropdown>
                                <DropdownToggle color="link" className="p-0">
                                    <img width={42} className="rounded-circle" src={avatar} alt="Avatar"/>
                                    <FontAwesomeIcon className="ml-2 opacity-8" icon={faAngleDown}/>
                                </DropdownToggle>
                                <DropdownMenu right className="rm-pointers dropdown-menu-lg">
                                    <div className="dropdown-menu-header">
                                        <div className="dropdown-menu-header-inner bg-info">
                                            <div className="menu-header-image opacity-1"
                                                 style={{backgroundImage: 'url(' + city3 + ')'}}/>
                                            <div className="menu-header-content text-left">
                                                <div className="widget-content p-0">
                                                    <div className="widget-content-wrapper">
                                                        <div className="widget-content-left mr-3">
                                                            <img width={42} className="rounded-circle" src={avatar}
                                                                 alt="Avatar"/>
                                                        </div>
                                                        <div className="widget-content-left">
                                                            <div className="widget-heading">{sub}</div>
                                                            <div className="widget-subheading opacity-10">{email}</div>
                                                            <div className="widget-subheading opacity-10">{role}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <Nav vertical>
                                        <NavItem className="nav-item-header">
                                            <Link to={`/admin/user/${id}`}>
                                                <FontAwesomeIcon icon={faUserCircle}/> Mi Perfil
                                            </Link>
                                        </NavItem>
                                    </Nav>
                                    <Nav vertical>
                                        <NavItem className="nav-item-divider"/>
                                        <NavItem className="nav-item-btn text-center pt-0 pb-0">
                                            <Button className="btn-pill btn-shadow btn-shine" color="danger"
                                                    onClick={logOut}>
                                                <FontAwesomeIcon icon={faPowerOff}/> Cerrar Sesión
                                            </Button>
                                        </NavItem>
                                    </Nav>
                                </DropdownMenu>
                            </UncontrolledButtonDropdown>
                        </div>
                        <div className="widget-content-left ml-3 header-user-info">
                            <div className="widget-heading">{sub}</div>
                            <div className="widget-subheading opacity-9">{email}</div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default UserBox
